import { Button, Stack, Switch, ToggleButtonGroup } from '@healthinal/ui';
import { useAtom } from 'jotai';
import { TaskFilter, taskFilterAtom, taskIncludeCompletedAtom } from '../../../state/taskSearchAtoms.ts';
import { getTaskFilterName } from '../../../utils/taskSearch/taskFilter.ts';
import { TaskFilterMenu } from './TaskFilterMenu.tsx';
import { TaskSortMenu } from './TaskSortMenu.tsx';

export function TaskHeaderFilter() {
  const [taskFilter, setTaskFilter] = useAtom(taskFilterAtom);
  const [includeCompleted, setIncludeCompleted] = useAtom(taskIncludeCompletedAtom);

  return (
    <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
      <ToggleButtonGroup value={taskFilter}>
        {Object.values(TaskFilter).map((filter) => (
          <Button key={filter} value={filter} onClick={() => setTaskFilter(filter)}>
            {getTaskFilterName(filter)}
          </Button>
        ))}
      </ToggleButtonGroup>
      <Stack direction={'row'} gap={2} alignItems={'center'}>
        <Switch
          endDecorator={'Erledigte anzeigen'}
          checked={includeCompleted}
          onClick={() => setIncludeCompleted(!includeCompleted)}
        />
        <TaskSortMenu />
        <TaskFilterMenu />
      </Stack>
    </Stack>
  );
}
